import {Component, ViewChild, OnInit, ElementRef, Renderer2} from '@angular/core';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {Globals} from '@app/services/globals.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {
    NgbDatepicker,
    NgbInputDatepicker,
    NgbDateStruct,
    NgbCalendar,
    NgbDateAdapter,
    NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import {NgModel} from "@angular/forms";
import {FileDownloadService} from "@app/services/file-download.service";
import {cloneDeep} from "lodash";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";
import {TimelineService} from "@components/timeline/timeline.service";


const now = new Date();
const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
    one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
        ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
        ? false : one.day > two.day : one.month > two.month : one.year > two.year;

interface FilteredTask {
    _id: string,
    status: string,
    created_by: number,
    identifier: string,
    sort: string,
    end_time: string,
    validation_returns: number,
    backlog: boolean,
    title: string,
    description: string,
    assigned: any[],
    validator_id: any[],
    project_id: any, //moze biti i integer ako dolazi iz proventuma
    meeting_time: any,
    type: string,
    deadline: string,
    execution: string,
    project: any,
    creatorData: any,
    validatorsData: any[],
    created_at: any;
    assignedData: any[],
}

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit {

    executingExcelExport = null;

    tasks: FilteredTask[] = [];
    assignedArray: any[];
    users = [];
    pageNum = 1;

    page = 1;
    pageSize = 15;
    serialNumber = 1;
    collectionSize: number = 0;
    fileName = 'TasksExcel.xlsx';


    assigned = '';
    validator = '';
    creator = '';

    admin = false;
    showLoader = true;

    showAll = false;
    deadlineAsc = false;


    //moze da bude univerzalno
    maxDate: NgbDateStruct;
    minDate: NgbDateStruct;


    //date range za deadline
    startDateDeadline: NgbDateStruct;
    hoveredDateDeadline: NgbDateStruct;

    fromDateDeadline: any;
    toDateDeadline: any;
    model: any;

    start = 0;
    limit = 15;
    previousPage = 1;

    disabledButton:boolean = false;

    @ViewChild("deadline_date_range") input: NgbInputDatepicker;
    @ViewChild(NgModel) datePick: NgModel;
    @ViewChild('deadlineRangeInput') deadlineRangeInput: ElementRef;

    isHoveredDeadline = date => this.fromDateDeadline && !this.toDateDeadline && this.hoveredDateDeadline && after(date, this.fromDateDeadline) && before(date, this.hoveredDateDeadline);
    isInsideDeadline = date => after(date, this.fromDateDeadline) && before(date, this.toDateDeadline);
    isFromDeadline = date => equals(date, this.fromDateDeadline);
    isToDeadline = date => equals(date, this.toDateDeadline);
////////////////////////////////////////////////////////////////////////


    //date range za execution
    startDateExecution: NgbDateStruct;
    hoveredDateExecution: NgbDateStruct;
    @ViewChild("execution_date_range") inputExecution: NgbInputDatepicker;
    @ViewChild(NgModel) datePickExecution: NgModel;
    @ViewChild('executionRangeInput') executionRangeInput: ElementRef;

    fromDateExecution: any;
    toDateExecution: any;
    modelExecution: any;


    isHoveredExecution = date => this.fromDateExecution && !this.toDateExecution && this.hoveredDateExecution && after(date, this.fromDateExecution) && before(date, this.hoveredDateExecution);
    isInsideExecution = date => after(date, this.fromDateExecution) && before(date, this.toDateExecution);
    isFromExecution = date => equals(date, this.fromDateExecution);
    isToExecution = date => equals(date, this.toDateExecution);


    //////////////////////////////////////////

    //date range za kraj izvrsavanja
    startDateEndDate: NgbDateStruct;
    hoveredDateEndDate: NgbDateStruct;
    @ViewChild("end_date_date_range") inputEndDate: NgbInputDatepicker;
    @ViewChild(NgModel) datePickEndDate: NgModel;
    @ViewChild('endDateRangeInput') endDateRangeInput: ElementRef;

    fromDateEndDate: any;
    toDateEndDate: any;
    modelEndDate: any;


    isHoveredEndDate = date => this.fromDateEndDate && !this.toDateEndDate && this.hoveredDateEndDate && after(date, this.fromDateEndDate) && before(date, this.hoveredDateEndDate);
    isInsideEndDate = date => after(date, this.fromDateEndDate) && before(date, this.toDateEndDate);
    isFromEndDate = date => equals(date, this.fromDateEndDate);
    isToEndDate = date => equals(date, this.toDateEndDate);

    dateRange:any;
    dateRangeCreation:any;
    filteredTasks: any[];

    startCreationDateExecution: NgbDateStruct;
    hoveredDateCreationDate: NgbDateStruct;
    @ViewChild("creation_date_range") creationInput: NgbInputDatepicker;
    @ViewChild(NgModel) dateCreationPick: NgModel;
    @ViewChild('creationDateRangeInput') creationDateRangeInput: ElementRef;

    fromCreationDateDeadline: any;
    toCreationDateDeadline: any;
    modelCreationDate: any;

    isHoveredCreationDate = date => this.fromCreationDateDeadline && !this.toCreationDateDeadline && this.hoveredDateCreationDate && after(date, this.fromCreationDateDeadline) && before(date, this.hoveredDateCreationDate);
    isInsideCreationDate = date => after(date, this.fromCreationDateDeadline) && before(date, this.toCreationDateDeadline);
    isFromCreationDate = date => equals(date, this.fromCreationDateDeadline);
    isToCreationDate = date => equals(date, this.toCreationDateDeadline);

    statuses = [{'name': 'Otvoren', value: 'todo', selected: true},
        {'name': 'U radu', value: 'inprogress', selected: true},
        {'name': 'Završen', value: 'ddone', selected: true},
        {'name': 'Otkazan', value: 'canceled', selected: true},
        {'name': 'Odložen', value: 'postponed', selected: true},
        {'name': 'Odobren', value: 'validated', selected: true},
        {'name': 'Izbrisan', value: 'deleted', selected: false},
        {'name': 'Ponovo izvrsavan', value: 'validation_returns', selected: false},
    ];

    datasForTable = {
        Naslov: '',
        Opis: '',
        Tip: '',
        Odgovorni: [],
        Validator: [],
        Kreator: [],
        status: this.statuses.filter(item => item.selected == true),
        Projekat: '',
        Pocetak: [],
        Kraj: [],
        Rok: [],
        Kreirano: [],
        Identifikator: ''
    };

    constructor(public taskService: TaskService,
                public proventumApiService: ProventumApiService,
                public globals: Globals,
                private constants: ConstantsService,
                private renderer: Renderer2,
                private _parserFormatter: NgbDateParserFormatter,
                private downloadService: FileDownloadService,
                private toastr: ToastrService,
                private timelineService: TimelineService) {
                    this.setExcelExportButton();
    }

    async ngOnInit() {
        this.startDateDeadline = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
        this.maxDate = {year: now.getFullYear() + 1, month: now.getMonth() + 1, day: now.getDate()};
        this.minDate = {year: now.getFullYear() - 24, month: now.getMonth() + 1, day: now.getDate()};

        this.startDateExecution = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
        this.startDateEndDate = {year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};


        if (this.constants.creator_id == '') {
            await this.getUserData();
        } else {
            const admins: any[] = this.constants.getAdmins();
            const i = admins.indexOf(parseInt(this.constants.creator_id, 10));
            if (i > -1) {
                this.admin = true;
            }
        }
        await this.getUsers();
        this.drawTable();

    }

    getUserData() {
        return new Promise((resolve, reject) => {
            try {
                if (localStorage.getItem('userId') !== null) {
                    this.proventumApiService.getUser(localStorage.getItem('userId')).subscribe(data => {
                        const admins: any[] = this.constants.getAdmins();
                        const i = admins.indexOf(parseInt(data.id));
                        if (i > -1) {
                            this.admin = true;
                        }
                        this.constants.setCreator(data.id);
                        resolve(true);

                    });
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    onDateSelection(date: NgbDateStruct, type) {
        let parsed = '';

        if (type === 'deadline') {
            if (!this.fromDateDeadline && !this.toDateDeadline) {
                this.fromDateDeadline = date;
            } else if (this.fromDateDeadline && !this.toDateDeadline && (after(date, this.fromDateDeadline) || equals(date, this.fromDateDeadline))) {
                this.toDateDeadline = date;

                this.input.close();
            } else {
                this.toDateDeadline = null;
                this.fromDateDeadline = date;
            }
            if (this.fromDateDeadline) {
                parsed += this._parserFormatter.format(this.fromDateDeadline);
            }
            if (this.toDateDeadline) {
                parsed += ' - ' + this._parserFormatter.format(this.toDateDeadline);
            }

            this.renderer.setProperty(this.deadlineRangeInput.nativeElement, 'value', parsed);
            let deadlineObj = {from: this.fromDateDeadline, to: this.toDateDeadline};
            this.datasForTable.Rok = [deadlineObj];


        } else if (type === 'execution') {
            if (!this.fromDateExecution && !this.toDateExecution) {
                this.fromDateExecution = date;
            } else if (this.fromDateExecution && !this.toDateExecution && (after(date, this.fromDateExecution) || equals(date, this.fromDateExecution))) {
                this.toDateExecution = date;
                this.inputExecution.close();
            } else {
                this.toDateExecution = null;
                this.fromDateExecution = date;
            }
            if (this.fromDateExecution) {
                parsed += this._parserFormatter.format(this.fromDateExecution);
            }
            if (this.toDateExecution) {
                parsed += ' - ' + this._parserFormatter.format(this.toDateExecution);
            }

            this.renderer.setProperty(this.executionRangeInput.nativeElement, 'value', parsed);
            let obj = {from: this.fromDateExecution, to: this.toDateExecution};
            this.datasForTable.Pocetak = [obj];

        } else if (type === 'endDate') {
            if (!this.fromDateEndDate && !this.toDateEndDate) {
                this.fromDateEndDate = date;
            } else if (this.fromDateEndDate && !this.toDateEndDate && (after(date, this.fromDateEndDate) || equals(date, this.fromDateEndDate))) {
                this.toDateEndDate = date;
                this.inputEndDate.close();
            } else {
                this.toDateEndDate = null;
                this.fromDateEndDate = date;
            }
            if (this.fromDateEndDate) {
                parsed += this._parserFormatter.format(this.fromDateEndDate);
            }
            if (this.toDateEndDate) {
                parsed += ' - ' + this._parserFormatter.format(this.toDateEndDate);
            }

            this.renderer.setProperty(this.endDateRangeInput.nativeElement, 'value', parsed);
            let obj = {from: this.fromDateEndDate, to: this.toDateEndDate}
            this.datasForTable.Kraj = [obj];

        } else if (type === 'creationDate') {
            if (!this.fromCreationDateDeadline && !this.toCreationDateDeadline) {
                this.fromCreationDateDeadline = date;
            } else if (this.fromCreationDateDeadline && !this.toCreationDateDeadline && (after(date, this.fromCreationDateDeadline) || equals(date, this.fromCreationDateDeadline))) {
                this.toCreationDateDeadline = date;

                this.creationInput.close();
            } else {
                this.toCreationDateDeadline = null;
                this.fromCreationDateDeadline = date;
            }
            if (this.fromCreationDateDeadline) {
                parsed += this._parserFormatter.format(this.fromCreationDateDeadline);
            }
            if (this.toCreationDateDeadline) {
                parsed += ' - ' + this._parserFormatter.format(this.toCreationDateDeadline);
            }

            this.renderer.setProperty(this.creationDateRangeInput.nativeElement, 'value', parsed);
            let deadlineObj = {from: this.fromCreationDateDeadline, to: this.toCreationDateDeadline};
            this.datasForTable.Kreirano = [deadlineObj];
        }


    }

    resetDateFilter(type) {
        switch (type) {
            case 'deadline':
                this.datasForTable.Rok = [];
                break;

            case 'endDate':
                this.datasForTable.Kraj = [];
                break;

            case 'execution':
                this.datasForTable.Pocetak = [];
                break;
        }
    }


    async drawTable() {
        this.datasForTable.status = this.statuses.filter(item => item.selected == true);

        this.showLoader = true;
        const filter = cloneDeep(this.datasForTable);
        filter.status = this.statuses.filter(item => item.selected === true);
        filter.Odgovorni = this.filterByString(this.assigned);
        filter.Validator = this.filterByString(this.validator);
        filter.Kreator = this.filterByString(this.creator);

        this.timelineService.getAllForTable(filter, this.showAll, this.pageNum, this.deadlineAsc).subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.tasks = response.data['tasks'];
                this.showLoader = false;
                this.collectionSize = +response.data['total'];
            } else {
                this.toastr.error('Došlo je do greške. Molimo Vas, obratite se korisničkoj podršci');
            }
        });

    }

    public onPageChange(pageNum) {
        this.previousPage = this.pageNum;
        this.pageNum = pageNum;
        this.serialNumber = pageNum !== 1 ? 1 + (this.pageSize * (pageNum) - this.pageSize) : 1;
        this.drawTable();
    }

    resetFilter() {

        this.statuses = [{'name': 'Otvoren', value: 'todo', selected: true},
            {'name': 'U radu', value: 'inprogress', selected: true},
            {'name': 'Završen', value: 'ddone', selected: true},
            {'name': 'Otkazan', value: 'canceled', selected: true},
            {'name': 'Odložen', value: 'postponed', selected: true},
            {'name': 'Odobren', value: 'validated', selected: true},
            {'name': 'Izbrisan', value: 'deleted', selected: false},
            {'name': 'Ponovo izvrsavan', value: 'validation_returns', selected: false},
        ];

        this.tasks = [];
        this.model = '';
        this.modelCreationDate = '';
        this.modelEndDate = '';
        this.modelExecution = '';
        this.showLoader = true;
        this.assigned = '';
        this.validator = '';
        this.creator = '';
        this.datasForTable = {
            Naslov: '',
            Opis: '',
            Tip: '',
            Odgovorni: [],
            Validator: [],
            status: this.statuses.filter(item => item.selected == true),
            Kreator: [],
            Projekat: '',
            Pocetak: [],
            Kraj: [],
            Rok: [],
            Kreirano: [],
            Identifikator: ''
        };

        this.fromCreationDateDeadline = null;
        this.toCreationDateDeadline = null;
        this.fromDateDeadline = null;
        this.toDateDeadline = null;

        this.drawTable();
    }

    getAllApplicationUser() {
        return new Promise((resolve, reject) => {
            try {
                const fun3 = this.proventumApiService.getUsers().subscribe(response => {
                    this.globals.setUsers(response);
                    this.users = response;
                });
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }

    getXls() {
        this.disabledButton= true;
        const payload = cloneDeep(this.datasForTable);
        payload.status = this.statuses.filter(item => item.selected === true);
        payload.Odgovorni = this.filterByString(this.assigned);
        payload.Validator = this.filterByString(this.validator);
        payload.Kreator = this.filterByString(this.creator);
        this.toastr.info('Pokrenuto je preuzimanje podataka. Molimo Vas budite strpljivi, uskoro ce podaci biti preuzeti.');
        this.setExcelExportButton("Export u toku...", true);
        this.timelineService.exportData(payload, this.showAll, this.deadlineAsc).subscribe(data => {
            this.setExcelExportButton();
            if (data['type'] === 'success') {
                this.downloadService.urlToBase64(data);
            }
        });
    }

    previewAllTasks(event) {
        this.showAll = event.target.checked;
        this.pageNum = 1;
        this.tasks = [];
        this.drawTable();
    }

    sortDeadline() {
        this.deadlineAsc = !this.deadlineAsc;
        this.drawTable();
    }

    checkStatus(index) {
        this.statuses[index].selected = !this.statuses[index].selected;
    }

    getUsers() {
        return new Promise((reslove, reject) => {
            try {
                let users: any[] = this.globals.getAllUsers();
                if (users.length == 0) {
                    this.getAllApplicationUser();
                    reslove();
                } else {
                    this.users = users;
                    reslove();
                }
            } catch (e) {
                reject(e);
            }
        })
    }

    filterByString(str: string) {
        if (str) {
            let users = this.users.filter(user => {
                let username = user.first_name + ' ' + user.last_name;
                return username.toLowerCase().includes(str.toLowerCase());
            });
            users = users.map(item => item.id);
            return users;
        } else return [];

    }

    setExcelExportButton(label="Export XLS",disabled=false): void {
        this.executingExcelExport = {
            label,
            disabled
        };
    }

}
